import { render, staticRenderFns } from "./fillterList.vue?vue&type=template&id=fa36fca6&scoped=true&"
import script from "./fillterList.vue?vue&type=script&lang=js&"
export * from "./fillterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa36fca6",
  null
  
)

export default component.exports